import {
    AppBar,
    Box, Chip, Stack,
    Toolbar,
    Typography
} from "@mui/material";
import React, {PropsWithChildren} from "react";
import "./NavBar.css"
import contactInfo from "../../util/Links";
import {smokyBlack} from "../../colours/scheme";


interface NavElementProps {
    href ?: string
}
function NavElement({href, children}: PropsWithChildren<NavElementProps>) {
    return <Typography sx={{ flexGrow: 1 }} variant="h6"> {children}</Typography>
}

export default function NavBar() {
    const contents = ["Commissions"]
    return <Box px={{lg: 25, xs: 0}} pt={{lg: 5, xs:0}}>
        <AppBar position="static">
            <Toolbar component={Stack}
                     direction={{md: "row", xs: "column"}}
                     spacing={2}
            >
                <Typography variant="h6">Azuraga Melody</Typography>
                <Typography variant="h6">/</Typography>
                {contents.map(title => <NavElement>{title}</NavElement>)}
                {Object.values(contactInfo).map(({name, link, Icon}) =>
                    <Chip
                        icon={Icon && <Icon/>}
                        label={name}
                        component="a"
                        href={link}
                        clickable
                        sx={{backgroundColor: smokyBlack}}
                    />
                )}
                <Typography variant="h6">MiD//RA </Typography>

            </Toolbar>
        </AppBar>

    </Box>
}